import React from "react";
import { SideTab } from "../../../../components/SideTab";
import { TitleLine } from "../../../../components/TitleLine";
import { Button } from "../../../../components/common/Button";
import { Input } from "../../../../components/common/Input";
import { Box, ButtonContainer, Row } from "../../styles";
import MapTracking from "../MapTracking";

interface OccurrenceUserDetailsSidebarProps {
  occurrenceUserDetails: any;
  isOpen: boolean;
  onClose: () => void;
  securityRedirect: boolean;
  onTriggerSecurity: () => void;
}

export function OccurrenceUserDetailsSidebar({
  occurrenceUserDetails,
  isOpen,
  onClose,
  securityRedirect,
  onTriggerSecurity,
}: OccurrenceUserDetailsSidebarProps) {
  return (
    
    <SideTab
      open={isOpen}
      width="40%"
      title={
        "#" +
        (occurrenceUserDetails?.code || "") +
        " - Ocorrência de " +
        (occurrenceUserDetails?.type || "")
      }
      toggleFunction={onClose}
    >
      <Input.Root>
        <Input.Label title="Quem solicitou:" htmlFor="occurrenceName" />
        <Input.Wrapper>
          <Input.Content
            id="occurrenceName"
            type="text"
            value={occurrenceUserDetails?.name || "-"}
            readOnly
          />
        </Input.Wrapper>
      </Input.Root>

      <Row>
        <Input.Root flex="1">
          <Input.Label title="Horário de envio:" htmlFor="" />
          <Input.Wrapper>
            <Input.Content
              id=""
              type="text"
              value={occurrenceUserDetails?.created_at ? new Date(
                occurrenceUserDetails.created_at
              ).toLocaleDateString() : "-"}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root flex="1">
          <Input.Label title="Modalidade:" htmlFor="" />
          <Input.Wrapper>
            <Input.Content
              id=""
              type="text"
              value={occurrenceUserDetails?.type || "-"}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root flex="1">
          <Input.Label title="Posto:" htmlFor="" />
          <Input.Wrapper>
            <Input.Content
              id=""
              type="text"
              value={occurrenceUserDetails?.code || "-"}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
      </Row>

      <Input.Root>
        <Input.Label title="Quem está atuando no caso:" htmlFor="" />
        <Input.Wrapper>
          <Input.Content
            id=""
            type="text"
            value={occurrenceUserDetails?.name || "-"}
            readOnly
          />
        </Input.Wrapper>
      </Input.Root>

      <TitleLine title="Objetivo da ocorrência" />
      <Input.Root>
        <Input.Wrapper>
          <Input.Content
            id=""
            type="text"
            value={occurrenceUserDetails?.name || "-"}
            readOnly
          />
        </Input.Wrapper>
      </Input.Root>

      <TitleLine title="Identificação do usuário" />
      <Row>
        <Input.Root flex="1">
          <Input.Label title="Veículo do usuário:" htmlFor="" />
          <Input.Wrapper>
            <Input.Content
              id=""
              type="text"
              value={occurrenceUserDetails?.created_at || "-"}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root flex="1">
          <Input.Label title="Cor do carro:" htmlFor="" />
          <Input.Wrapper>
            <Input.Content
              id=""
              type="text"
              value={occurrenceUserDetails?.type || "-"}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root flex="1">
          <Input.Label title="Placa:" htmlFor="" />
          <Input.Wrapper>
            <Input.Content
              id=""
              type="text"
              value={occurrenceUserDetails?.code || "-"}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
      </Row>

      <TitleLine title="Mapa do percurso em tempo real" />
      <Box padding="0">
        <MapTracking occurrence={occurrenceUserDetails} />
      </Box>

      {securityRedirect ? (
        <>
          <Row>
            <Input.Root flex="1">
              <Input.Label title="Segurança:" htmlFor="" />
              <Input.Wrapper>
                <Input.Content
                  id=""
                  type="text"
                  value={occurrenceUserDetails.Occurrence?.created_at || "-"}
                  readOnly
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root flex="1">
              <Input.Label title="Veículo:" htmlFor="" />
              <Input.Wrapper>
                <Input.Content
                  id=""
                  type="text"
                  value={occurrenceUserDetails.Occurrence?.type || "-"}
                  readOnly
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root flex="1">
              <Input.Label title="Placa:" htmlFor="" />
              <Input.Wrapper>
                <Input.Content
                  id=""
                  type="text"
                  value={occurrenceUserDetails.Occurrence?.code || "-"}
                  readOnly
                />
              </Input.Wrapper>
            </Input.Root>
          </Row>
          <Row>
            <Input.Root flex="2">
              <Input.Label title="Ação do momento:" htmlFor="" />
              <Input.Wrapper>
                <Input.Content
                  id=""
                  type="text"
                  value={occurrenceUserDetails.Occurrence?.created_at || "-"}
                  readOnly
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root flex="1">
              <Input.Label
                title="Tempo previsto de chegada"
                htmlFor=""
              />
              <Input.Wrapper>
                <Input.Content
                  id=""
                  type="text"
                  value={occurrenceUserDetails.Occurrence?.type || "-"}
                  readOnly
                />
              </Input.Wrapper>
            </Input.Root>
          </Row>
        </>
      ) : (
        <ButtonContainer>
          <Button.Root
            type="button"
            backgroundColor="#0079B1"
            onClick={onTriggerSecurity}
          >
            <Button.Content
              title="Acionar um segurança"
              fontSize="12px"
            />
          </Button.Root>
        </ButtonContainer>
      )}
    </SideTab>
  );
}
